import { ModelBase } from '../../core/model/model-base';

export class UserGroup extends ModelBase {
  constructor(dataContext?: any) {
    super();
    if (dataContext) {
      this.id = dataContext.id;
      this.name = dataContext.name;
      this.users = dataContext.users;
      this.features = dataContext.features;
      this.systemGroup = dataContext.systemGroup;
      this.hasConfidentialErrandAccess = dataContext.hasConfidentialErrandAccess;
      this.accessRestrictions = dataContext.accessRestrictions ?? [];
    }
  }

  name: string;
  users: string[] = [];
  features: string[] = [];
  systemGroup: boolean;
  hasConfidentialErrandAccess = false;
  accessRestrictions: UserGroupAccessRestriction[] = [];
}

export interface UserGroupAccessRestriction {
  id: string;
  name: string;
  isEnabled: boolean;
  isConfidential: boolean;
  isAssigned: boolean;
}
